import React from 'react'
import _ from 'lodash'

import {AccommodationList} from '../accommodations/accommodationlist.component'
import {ActivityList} from '../activities/activitylist.component'
import {TravelList} from '../travel/travellist.component'

export class LegOverview extends React.Component {
    constructor(props) {
        super(props)  

        _.bindAll(this,
    	'getListHeader',
            'getListHeaderContent'
        )
    }

    getListHeaderContent(section) {
    // defaults
        let icon        = null
        let headerText  = null
        let body        = <i className="icon-complete green"/> // override if we don't have the item
        let btn         = <a
                        onClick={() => this.props.updateDetailSections(this.props.leg, section, this.props.availableDetailSubSections.SEARCH) }
                        className="btn inactive">
                        EXPLORE
        </a>

        switch (section) {
            case 'ACCOMMODATIONS':
                icon        = <i className="icon-hotel"/>
                headerText  = <h1>Accommodations</h1>
                if (!this.props.hasAccommodation) {
                    body = <span>
                  Get started with your accommodations. Luna selects the most romantic hotels for your honeymoon. 
                    </span>
                    btn = <a
                  onClick={() => this.props.updateDetailSections(this.props.leg, section, this.props.availableDetailSubSections.SEARCH) }
                  className="btn">
                  START
                    </a>
                }
                break
            case 'ACTIVITIES':
                icon        = <i className="icon-bicycle"/>
                headerText  = <h1>Activities</h1>
                if (!this.props.hasActivity) {
                    body = <span>
                  Select from our list of things to do including museums, restaurants, and our favorite landmarks. 
                    </span>
                    btn = <a
                  onClick={() => this.props.updateDetailSections(this.props.leg, section, this.props.availableDetailSubSections.SEARCH) }
                  className="btn">
                  START
                    </a>
                }
                break
            case 'TRAVEL':
                icon        = <i className="icon-plane_right"/>
                headerText  = <h1>Travel</h1>
                if (!this.props.hasTravel) {
                    body = <span>
                  Plan the best route to get to, from and around your destination. 
                    </span>
                    btn = <a
                  onClick={() => this.props.updateDetailSections(this.props.leg, section, this.props.availableDetailSubSections.OVERVIEW) }
                  className="btn">
                  START
                    </a>
                }
                break
            default:
                console.log('There was an error formatting the helper block')
                return ''
        }
        return (
            <div className="leg-overview-helper-block">
                <div className="leg-overview-block-header">
                    {icon}
                    {headerText}        
                </div>
                <div className="leg-overview-block-body">
                    {body}     
                    <div className="leg-overview-block-actions">
                        {btn}
                        <a
              onClick={() => this.props.updateDetailSections(this.props.leg, section, this.props.availableDetailSubSections.LUNA) }
              className="btn-flex btn-assist">
                            <i className="icon-diamond"/> ASSIST
                        </a>
                    </div>   
                </div>
            </div>
        )
    }

    getListHeader() {
  	if (this.props.hasAccommodation && this.props.hasActivity && this.props.hasTravel) {
  		// we have everything, don't show header
  		return ''
  	} else if (this.props.hasAccommodation || this.props.hasActivity || this.props.hasTravel) {
            if (this.props.isLunaTrip) {
                return (
                    <div className="helper-block">
                        <h1>Luna Trip recommendations for {this.props.leg.getIn(['destination', 'title'])}</h1>
                        <p>
                We've hand selected hotels and activities for this Luna Trip.<br/>
                Explore our lists below or discover more options from Luna's curated inventory.                
                        </p>
                    </div>
                )
            } else {
                // we have at least one thing
                return (
                    <div className="leg-overview-block">
                        { this.getListHeaderContent(this.props.availableDetailSections.ACCOMMODATIONS) }
                        { this.getListHeaderContent(this.props.availableDetailSections.ACTIVITIES) }
                        { this.getListHeaderContent(this.props.availableDetailSections.TRAVEL) }
                    </div>
                )
            }
  	} else {
            // we have nothing yet, include helper text
            return (
                <div>
                    <div className="helper-block">
                        <h1>Let's Get Started</h1>
                        <p>Start exploring or let Luna take care of the details using Luna Assist</p>
                    </div>
                    <div className="leg-overview-block">
                        { this.getListHeaderContent(this.props.availableDetailSections.ACCOMMODATIONS) }
                        { this.getListHeaderContent(this.props.availableDetailSections.ACTIVITIES) }
                        { this.getListHeaderContent(this.props.availableDetailSections.TRAVEL) }
                    </div>
                </div>
            )
        }
    }

    render() {
        let accommodationBlock  = this.props.leg.get('accommodations').size > 0  ? <AccommodationList {...this.props}/> : null
        let activityBlock       = this.props.leg.get('activities').size > 0    ? <ActivityList {...this.props}/> : null
        let travelBlock         = this.props.leg.get('transportation').size > 0  ? <TravelList {...this.props}/> : null


	    return (
    	<div>
        <div className="view-area">
            <div className="view-left-col"/>
            <div className="view-center">
                {this.getListHeader()}
            </div>
            <div className="view-right-col"/>
        </div>
        {accommodationBlock}
        {activityBlock}
        {travelBlock}
    </div>
        )
    }
}